export enum SortationFeature {
  CUSTOMS_SCAN_ENABLED = "customs_scan_sortation_portal",
  GAYLORD_TYPE_ENABLED = "gaylord_type_sortation_portal",
}
